import type { ResourceType } from '../../../shared/types/access';
import type { FeatureManifest } from './registry';
import { boardsFeature } from './boards';
import { retrosFeature } from './retros';
import { goalsFeature } from './goals';

export const features: FeatureManifest[] = [boardsFeature, retrosFeature, goalsFeature];

export function featureFor(type: ResourceType): FeatureManifest {
    const manifest = features.find(f => f.type === type);
    if (!manifest) throw new Error(`Unknown resource type: ${type}`);
    return manifest;
}
